import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { CUSTOM_OVERLAY_VIEWS, CustomOverlayService } from '../../services/custom-overlay.service';
import { OPTIONS } from '../constants/options-list.constants';
import { emptyAreaOptions } from '../constants/documents.constants';

@Component({
  selector: 'app-drive-empty-area',
  imports: [],
  templateUrl: './drive-empty-area.component.html',
  styleUrls: ['./drive-empty-area.component.scss'],
})
export class DriveEmptyAreaComponent implements OnDestroy {
  @Output() registerEmptyAreaOption = new EventEmitter<OPTIONS>();

  private isDestroyed$ = new Subject<void>();
  constructor(private overlayService: CustomOverlayService) {}

  ngOnDestroy() {
    this.isDestroyed$.next();
    this.isDestroyed$.complete();
  }

  openEmptyOverlay(event: MouseEvent) {
    if (this.overlayService.isOpened()) {
      this.overlayService.closeOverlay();
    }

    this.overlayService.openOverlay(
      {
        x: event.pageX,
        y: event.pageY,
      },
      { listItems: emptyAreaOptions },
      CUSTOM_OVERLAY_VIEWS.STYLED_OPTIONS_LIST,
    );

    this.overlayService.outputData$.pipe(first()).subscribe((selectedOption: OPTIONS) => {
      this.registerEmptyAreaOption.emit(selectedOption);
    });
  }
}
